import { deserialize } from 'cerialize'
import { ShortDataModel } from 'Models'
import { SmsModel } from 'Pages/som'
import { AgreementModel } from 'Pages/admin/agreements/models/Agreement'
import { FileType, LEAD_BEARER, PARENT_TYPE_LEAD } from 'Pages/lead'
import { ONLINE_IDENTIFICATION, typeScenario } from 'Pages/registratorCabinet'

export class RbidosLeadModel {
	@deserialize public id: number
	@deserialize public state: string
	@deserialize public org_type: string
	@deserialize public phone: string
	@deserialize public email: string
	@deserialize public first_name: string
	@deserialize public last_name: string
	@deserialize public middle_name: string
	@deserialize public empty_middle_name: boolean
	@deserialize public sms_created_at: string
	@deserialize public created_at: string
	@deserialize public created_by_user: ShortDataModel
	@deserialize public parent_id?: number
	@deserialize public parent_type?: PARENT_TYPE_LEAD | null
	@deserialize public sms?: SmsModel[]
	@deserialize public partner?: any
	@deserialize public manager?: any
	@deserialize public link_token?: string
	@deserialize public completed_at?: string
	@deserialize public inn?: string
	@deserialize public timezone?: string
	@deserialize public digital?: boolean
	@deserialize public paper?: boolean
	@deserialize public os?: string
	@deserialize public browser?: string
	@deserialize public ip_address?: string
	@deserialize public permissions?: any
	@deserialize public bearer: LEAD_BEARER
	@deserialize public agreement?: AgreementModel
	@deserialize public area_name?: string | null
	@deserialize public activate_attempts_count?: number
	@deserialize public sberid_phone?: string
	@deserialize public with_reserve_account?: boolean | null
	@deserialize public notary_file?: FileType
	@deserialize public notary_file_file_name?: string | null
	@deserialize public notary_file_second?: FileType
	@deserialize public notary_file_second_file_name?: string | null
	@deserialize public notary_file_third?: FileType
	@deserialize public notary_file_third_file_name?: string | null
	@deserialize public department_id?: number
	@deserialize public sms_timer?: string
	@deserialize public request_params?: {
		parent_type: PARENT_TYPE_LEAD
		bearer: LEAD_BEARER
		email: string
		partner_id: number
		channel_id: number
		role_ids: string[]
		user_id: string
	}
	@deserialize public last_event?: ShortDataModel
	@deserialize public request_scenario?: typeScenario
	@deserialize public online_identification?: ONLINE_IDENTIFICATION
	@deserialize public department?: {
		name: string
		inn: string
	}
	@deserialize public user_department_id?: number
	@deserialize public department_for_agreement?: {
		id: string
		inn: string
		name: string
		ogrn: string
		address: string
	}
	@deserialize public parent_copied_from_id?: number
}
